// Damaged Product Actions

import Axios from 'axios'
import * as helpers from '@/mixins/helperFunctions.js'

// ***** Get damagedProductList from backend then update damagedProductList in vuex store ***** //
export const updateDamagedProductsList = async ({ commit }, payload = null) => {
  let params = {}

  if (payload) {
    params = {
      search: payload.search,
      page: payload.page,
      per_page: payload.rowsPerPage,
      column: payload.sortBy,
      sortDir: payload.descending ? 'desc' : 'asc'
    }
  }

  try {
    const result = await Axios.get('damaged_products_index', { params: params })
    commit('updateDamagedProductsList', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Get reportDamagedProductList from backend then update reportDamagedProductList in vuex store ***** //
export const updateReportDamagedProductsList = async ({ commit }, payload = null) => {
  let params = {}

  if (payload) {
    params = {
      search: payload.search,
      page: payload.page,
      per_page: payload.rowsPerPage,
      column: payload.sortBy,
      sortDir: payload.descending ? 'desc' : 'asc'
    }
  }

  try {
    const result = await Axios.get(`report_damaged_products/${payload.id}`, {
      params: params
    })
    commit('updateDamagedProductsList', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Fetch reportInventoryExpired from backend ***** //
export const fetchReportDamagedProductsCount = async ({ commit }, payload) => {
  try {
    const result = await Axios.get(`report_unclosed_damaged_products_count/${payload}`)
    commit('fetchDamagedProductsCount', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Fetch Damaged Product Info from backend ***** //
export const fetchDamagedProductInfo = async ({ commit }, payload = null) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    const result = await Axios.get(`damaged_products_show/${payload}`)
    commit('fetchDamagedProductInfo', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Fetch Damaged Product Info from backend ***** //
export const fetchUnclosedDamagedProductsCount = async ({ commit }) => {
  try {
    const result = await Axios.get('unclosed_damaged_products_count')
    commit('fetchUnclosedDamagedProductsCount', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Add Damaged Product  ***** //
export const addDamagedProduct = async (ignored, payload = null) => {
  try {
    await Axios.post('damaged_products_store', payload)
    helpers.ktNotify({
      type: 'success',
      text: 'Added Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, creation failed')
  }
}

// ***** Update Damaged Product info ***** //
export const updateDamagedProductInfo = async (ignored, payload = null) => {
  if (!helpers.checkId(payload.id)) {
    throw new Error('Error')
  }

  try {
    payload.formData.append('_method', 'PATCH')
    await Axios.post(`damaged_products_update/${payload.id}`, payload.formData)
    helpers.ktNotify({
      type: 'success',
      text: 'Updated Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, update failed')
  }
}

// ***** Close Damaged Product info ***** //
export const closeDamagedProduct = async (ignored, payload = null) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    await Axios.get(`damaged_products_close/${payload}`)
    helpers.ktNotify({
      type: 'success',
      text: 'Closed Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, update failed')
  }
}

// ***** Close Damaged Product info ***** //
export const uncloseDamagedProduct = async (ignored, payload = null) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    await Axios.get(`damaged_products_unclose/${payload}`)
    helpers.ktNotify({
      type: 'success',
      text: 'Opened Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, update failed')
  }
}

// ***** Delete Damaged Product  ***** //
export const deleteDamagedProduct = async (ignored, payload) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    await Axios.delete(`damaged_products_destroy/${payload}`)
    helpers.ktNotify({
      type: 'success',
      text: 'Deleted Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, deletion failed')
  }
}
